import type { Identifier } from "ra-core";

/** The "Competencia" module (its own section since it left Mercado). */
export const COMPETITORS_BASE = "/competencia";

export type CompetitorsTab = "competitors" | "trends" | "swot";

/** Tab order; the competitor list is the section index. */
export const COMPETITORS_TABS: readonly { id: CompetitorsTab; path: string }[] =
  [
    { id: "competitors", path: "" },
    { id: "trends", path: "tendencias" },
    { id: "swot", path: "foda" },
  ];

export const competitorsTabPath = (tab: CompetitorsTab): string => {
  const path = COMPETITORS_TABS.find((entry) => entry.id === tab)!.path;
  return path ? `${COMPETITORS_BASE}/${path}` : COMPETITORS_BASE;
};

export const trendsPath = competitorsTabPath("trends");
export const swotPath = competitorsTabPath("swot");

export const competitorPath = (id: Identifier): string =>
  `${COMPETITORS_BASE}/${encodeURIComponent(String(id))}`;

/** The SWOT tab with an analysis selected. */
export const swotAnalysisPath = (id: Identifier): string =>
  `${swotPath}?analisis=${encodeURIComponent(String(id))}`;

/** Tab of a /competencia/... path: a competitor's page belongs to the list. */
export const competitorsTabOfPath = (pathname: string): CompetitorsTab => {
  const segment = pathname.slice(COMPETITORS_BASE.length + 1).split("/")[0];
  return (
    COMPETITORS_TABS.find((tab) => tab.path && tab.path === segment)?.id ??
    "competitors"
  );
};

/** A competitor's page (/competencia/:id), not one of the tabs. */
export const isCompetitorDetailPath = (pathname: string): boolean => {
  const rest = pathname.slice(COMPETITORS_BASE.length + 1).split("/")[0];
  return (
    pathname.startsWith(`${COMPETITORS_BASE}/`) &&
    rest !== "" &&
    !COMPETITORS_TABS.some((tab) => tab.path === rest)
  );
};

/** Former home of the competitors, under Mercado. */
export const LEGACY_COMPETITORS_PATH = "/inteligencia/competidores";

/**
 * Maps /inteligencia/competidores[/:id][/...] to /competencia[/:id][/...]
 * (the query string, e.g. ?linea=, is kept by the caller).
 */
export const competitorsPathOf = (legacyPathname: string): string => {
  const rest = legacyPathname.slice(LEGACY_COMPETITORS_PATH.length);
  return rest && rest !== "/" ? `${COMPETITORS_BASE}${rest}` : COMPETITORS_BASE;
};
